import { hasUserPermission } from "helpers/ClaimHelpers";
import { ClaimPermission, ClaimResource, ParentClaim } from "types/claimTypes";

export type AuthoringPermissions = {
  canEdit: boolean;
  canApprove: boolean;
  canArchive: boolean;
  canSetAvailability: boolean;
};

/**
 * The four rights this screen offers, read separately: holding approve does not by itself allow
 * archiving, and setting tracker availability is its own right again. ClaimBasedComponent compares
 * the resource alone and cannot express any of this.
 */
const authoringPermissions = (): AuthoringPermissions => ({
  canEdit: hasUserPermission(
    ParentClaim.Accreditation,
    ClaimResource.LicenseRequirements,
    ClaimPermission.Edit
  ),
  canApprove: hasUserPermission(
    ParentClaim.Accreditation,
    ClaimResource.LicenseRequirements,
    ClaimPermission.Approve
  ),
  canArchive: hasUserPermission(
    ParentClaim.Accreditation,
    ClaimResource.LicenseRequirements,
    ClaimPermission.Archive
  ),
  canSetAvailability: hasUserPermission(
    ParentClaim.Accreditation,
    ClaimResource.LicenseTracker,
    ClaimPermission.Enable
  ),
});

export default authoringPermissions;
